var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BModalForm',_vm._b({ref:"modal",attrs:{"create-default-data":_vm.createDefaultData,"max-width":"900px"},on:{"closed":function($event){return _vm.$emit('closed')}},scopedSlots:_vm._u([{key:"title-text",fn:function(ref){
var editable = ref.editable;
var form = ref.form;
return [_vm._v(" "+_vm._s(_vm.getTitle(editable, form))+" ")]}},{key:"default",fn:function(ref){
var editable = ref.editable;
var form = ref.form;
var onSaveContinue = ref.onSaveContinue;
return [_c('RoadmapDirectionsForm',{attrs:{"form":form,"disabled":editable},on:{"save-continue":onSaveContinue}}),(form.id)?_c('RoadmapBaseEventsList',{staticClass:"mt-2",attrs:{"roadmap-id":_vm.roadmap_id,"direction-id":form.id}}):_vm._e()]}}])},'BModalForm',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }